export enum DataTypes {
  int = 'int',
  string = 'string',
  date = 'date',
  boolean = 'boolean',
  timestamp = 'timestamp',
  float = 'float',
  bigint = 'bigint',
}

export const DATA_TYPES = Object.values(DataTypes) as readonly DataTypes[];

/** Subset used for numeric columns and `numeric_data_types_list` schema fields. */
export const NUMERIC_DATA_TYPES = [DataTypes.int, DataTypes.bigint, DataTypes.float] as const;

export const NUMERIC_DATA_TYPE_SET: ReadonlySet<string> = new Set(NUMERIC_DATA_TYPES);